module.exports = __webpack_public_path__ + "static/golden-gate-logo-f31120bb4611e1bd093a9686ada2694f.png";